import { ButtonPropsWithLabel } from 'src/components/Dialog';
import { Stack } from 'src/components/Stack';

import { CustomBlockingReason } from './CustomBlockingReason';
import { PaymentRequiredReason } from './PaymentRequiredReason';
import { RequiredDocumentReason } from './RequiredDocumentReason';
import { CheckinBlockerUser } from './_types';

export function BlockingReasonList({
  blockers,
  getBlockerActions,
  userId,
}: {
  blockers: CheckinBlockerUser['blockers'];
  getBlockerActions?: (
    blocker: CheckinBlockerUser['blockers'][number]
  ) => ButtonPropsWithLabel[] | undefined;
  userId: string;
}) {
  return (
    <Stack spacing={1.5} sx={{ width: '100%' }}>
      {blockers.map((blocker, index) => {
        const key = `${blocker.type}-${index}`;
        switch (blocker.type) {
          case 'billing_blocked':
            return (
              <PaymentRequiredReason
                key={key}
                userId={userId}
                actions={getBlockerActions?.(blocker)}
                resolved={blocker.resolved}
              />
            );
          case 'waiver_required':
            return <RequiredDocumentReason key={key} />;
          default:
            return (
              <CustomBlockingReason
                key={key}
                message={blocker.message}
                actions={getBlockerActions?.(blocker)}
              />
            );
        }
      })}
    </Stack>
  );
}
